<template>
  <v-card
    color="cyan-lighten-5"
    elevation="4"
    rounded="lg"
    theme="light"
    width="100%"
  >
    <v-card-text v-if="value.title" class="pa-6">
      <v-row>
        <v-col class="text-h6"><StyledText :value="value.title" /></v-col>
      </v-row>
    </v-card-text>

    <v-card-text v-if="value.action && value.href" class="pb-6">
      <v-row>
        <v-col cols="12" align="center">
          <v-btn
            :append-icon="mdiArrowRight"
            :href="value.href"
            class="text-none"
            color="secondary"
            rounded="pill"
            size="large"
            >{{ value.action }}</v-btn
          >
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script setup>
import { mdiArrowRight } from '@mdi/js'

defineProps({
  value: {
    required: true,
    type: Object
  }
})
</script>
